import * as Yup from 'yup';

export const validationSchema: Yup.ObjectSchema<{}> = Yup.object().shape({
  provisionMethod: Yup.string(),
  connectionName: Yup.string().nullable().required('Please select a connection.'),
  defaultRole: Yup.string().nullable().required('Please select a default role.')
});
